import React from 'react';
import SendOtpContainer from 'containers/SendOtp';

const SendOtp = () => {
  return  (
    <>

    <SendOtpContainer />
    </>
  );
};

export default SendOtp;
